import React from 'react';
import classnames from 'classnames';

class OpenDNSBanner extends React.Component {
    render() {
        const identityClasses = classnames(
            'identity',
            { 'identity--umbrella': this.props.logoUrl }
        );
        const logoUrl = this.props.logoUrl ? this.props.logoUrl : '/images/logo-opendns.png';

        if (this.props.logoUrl) {
            return (
                <header>
                    <div className="container">
                        <div className={identityClasses}>
                            <a href="https://umbrella.cisco.com" target="_blank">
                                <img src={logoUrl} alt="Umbrella by OpenDNS" />
                            </a>
                        </div>
                    </div>
                </header>
            );
        }

        return(
            <header>
                <div className="container">
                    <div className={identityClasses}>
                        <img src={logoUrl} alt="OpenDNS" />
                    </div>
                </div>
            </header>
        );
    }
}

export default OpenDNSBanner;



// WEBPACK FOOTER //
// ./src/components/OpenDNSBanner.js